var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',[_c('ve-histogram',{ref:"bar-echarts",staticClass:"bar-echarts",attrs:{"data":_vm.optionData.data,"settings":_vm.optionData.settings,"colors":_vm.optionData.colors,"yAxis":_vm.optionData.yAxis,"tooltip":_vm.optionData.tooltip,"legend":_vm.optionData.legend,"grid":_vm.optionData.grid}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }